import Entity from '../entity'
export default class Tag extends Entity<number> {
    name: string;
    sortIndex: number;
}
